export const MyConsultationCn = {
    xunjiadang:'我的咨询',
    quanbu:'全部',
    zhixunzhong:'咨询中',
    yijieshu:'已结束',
    zuanjiaxinxi:'专家信息',
    zixunjindu:'咨询进度',
    caozuo:'操作'
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/MyConsultation/MyConsultationCn.js